module.exports = __webpack_public_path__ + "static/media/endoverdose.6e1e08c5.md";